import { observable, computed } from "mobx";
import MediaItemDownloadInfoSize from "~/constants/Media/MediaItemDownloadInfoSize";

class MediaItemDownloadInfo {
  /**
   * @property {string} mediaItemId the parent media id (fk)
   */
  @observable mediaItemId;

  /**
   * @property {string}
   */
  @observable title;

  /**
   * @property {string}
   */
  @observable description;

  /**
   * @property {string} one of MediaClassNames (see Media.js)
   */
  @observable className;

  /**
   * @property {string} size one of MediaDownloadInfoSizes
   */
  @observable size;

  /**
   * @property {string}
   */
  @observable downloadUrl;

  constructor({
    mediaItemId = null,
    title = null,
    description = null,
    className = null,
    size = null,
    downloadUrl = null,
  }) {
    this.mediaItemId = mediaItemId;
    this.title = title;
    this.description = description;
    this.className = className;
    this.size = size;
    this.downloadUrl = downloadUrl;

    if (size && Object.values(MediaItemDownloadInfoSize).indexOf(size) === -1) {
      throw new Error(`Unrecognized size: ${size}`);
    }
  }

  @computed
  get uuid() {
    return `${this.className}_${this.mediaItemId}_${this.size}`;
  }
}

export default MediaItemDownloadInfo;
